module.exports = __webpack_public_path__ + "static/media/line-gray.d8fdc116.svg";